module.exports = __webpack_public_path__ + "static/media/1013256.01fd7451.png";